export default [
    {
        path: '/',
        meta: {
        },
        component: () => import('@/views/index')
    },
    {
        path: '/fwshop',
        meta: {
        },
        component: () => import('@/views/1531/fwshop')
    }
]
